import {SLAReport, SLAReportService, SLAReportViewGroup, UptimeTotals} from "@/lib/queries/reports.ts";
import {SLAReportOverviewStats} from "@/pages/reports/sla/details/SLAReportOverviewStats.tsx";
import {SLAReportServicesTable} from "@/pages/reports/sla/details/SLAReportServicesTable.tsx";

interface SLAReportUptimeSectionProps {
  totals: UptimeTotals;
  items: SLAReportService[];
  report: SLAReport;
  groups: SLAReportViewGroup[];
}

export const SLAReportUptimeSection = ({items, groups, totals, report}: SLAReportUptimeSectionProps) => {
  let title = "Checks";
  if (report.filter_response_time_sla_violations) {
    title += "Below SLA";
  } else if (report.filter_with_downtime) {
    title += " with Downtime";
  }

  return (
    <div className="container">
      <h3 className="fw-semibold mb-4">Overview of Selected Checks</h3>
      <SLAReportOverviewStats {...totals} />
      <SLAReportServicesTable report={report} title={title} className="mt-4" items={items} groups={groups} />
    </div>
  );
};
